module.exports = __webpack_public_path__ + "img/nomorebottles.37da463e.png";